const OrderTypeDeliveryIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5371 28.4448V14.1855H32.3149L37.5001 20.667V28.4448H33.6112"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M5.09277 14.1855H16.7594"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 19.3711H14.1667"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 9H24.537V28.4444H16.7593"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M31.0184 31.0367C32.4502 31.0367 33.611 29.876 33.611 28.4442C33.611 27.0123 32.4502 25.8516 31.0184 25.8516C29.5865 25.8516 28.4258 27.0123 28.4258 28.4442C28.4258 29.876 29.5865 31.0367 31.0184 31.0367Z"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M10.2781 31.0367C11.71 31.0367 12.8707 29.876 12.8707 28.4442C12.8707 27.0123 11.71 25.8516 10.2781 25.8516C8.84629 25.8516 7.68555 27.0123 7.68555 28.4442C7.68555 29.876 8.84629 31.0367 10.2781 31.0367Z"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
);

export default OrderTypeDeliveryIcon;
